import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import type { BlogCategory, BlogTag } from '../../../../shared/models/blog.model';
import { SelectComponent, type SelectOption } from '../../../../shared/ui/select/select.component';
import { BlogSearchComponent } from '../blog-search/blog-search.component';
import { BLOG_COPY } from '../../constants/blog.constants';

@Component({
  selector: 'app-blog-filter-bar',
  imports: [SelectComponent, BlogSearchComponent],
  templateUrl: './blog-filter-bar.component.html',
  styleUrl: './blog-filter-bar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class BlogFilterBarComponent {
  categories = input.required<BlogCategory[]>();
  tags = input.required<BlogTag[]>();
  activeCategory = input<string | null>(null);
  activeTag = input<string | null>(null);
  searchValue = input('');
  /** `null` = no se pinta el contador (listado sin filtros, B131). */
  resultsCount = input<number | null>(null);

  categoryChange = output<string | null>();
  tagChange = output<string | null>();
  searchChange = output<string>();

  protected readonly copy = BLOG_COPY;

  protected readonly categoryOptions = computed<SelectOption[]>(() => [
    { value: '', label: BLOG_COPY.allCategories },
    ...this.categories().map(c => ({ value: c.slug, label: c.name })),
  ]);

  protected readonly tagOptions = computed<SelectOption[]>(() => [
    { value: '', label: BLOG_COPY.allTags },
    ...this.tags().map(t => ({ value: t.slug, label: t.name })),
  ]);

  protected onCategorySelect(value: string): void {
    this.categoryChange.emit(value || null);
  }

  protected onTagSelect(value: string): void {
    this.tagChange.emit(value || null);
  }
}
